module.exports = __webpack_public_path__ + "static/media/germanyflag.9c945dbb.jpg";